import { Inject, Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

// These libraries are having some platform type issues that are bubbling up.
// These imports are expected, working to resolve these separately.
// eslint-disable-next-line @nx/enforce-module-boundaries
import {
  EmbedActionType,
  EmbedReportActions,
  EmitMessages,
  EmitTransport,
  FilterPanelActions,
} from '@mode/reports/sandbox/contract';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { EmitTransportToken } from '@mode/reports/sandbox/util-transport';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { InitActionType } from '@mode/legacy/util-domain';

type ActionTypes = InitActionType | EmbedReportActions.Type | FilterPanelActions.Type | EmbedActionType;

// List of all actions that will be emitted to the parent frame
const EMITABLE_ACTIONS: Set<ActionTypes> = new Set([
  FilterPanelActions.Type.ApplyFilters,
  FilterPanelActions.Type.ApplyFiltersAndGenerateLink,
  FilterPanelActions.Type.DeleteFilter,
  FilterPanelActions.Type.MoveFilter,
  FilterPanelActions.Type.MoveFilterToBottom,
  FilterPanelActions.Type.ResetFilter,
  FilterPanelActions.Type.ResetFilters,
  FilterPanelActions.Type.SetAsDefault,
  FilterPanelActions.Type.SetFilterType,
  FilterPanelActions.Type.SetRangeIncludeNulls,
  FilterPanelActions.Type.SetSelectionControlType,
  FilterPanelActions.Type.SetHideSelectAll,
  FilterPanelActions.Type.ShowRelevantValues,
  FilterPanelActions.Type.ToggleFilterPanel,
  FilterPanelActions.Type.FilterPanelLoaded,
  FilterPanelActions.Type.FilterSelectionChange,
  EmbedActionType.AnalyticsEvent,
  EmbedActionType.Back,
  EmbedActionType.ChangeHierarchy,
  EmbedActionType.ClickChartMark,
  EmbedActionType.ClickDrilldownInterval,
  EmbedActionType.ClickExploreFromHere,
  EmbedActionType.ClickViewData,
  EmbedActionType.DrillDown,
  EmbedActionType.DynamicDrillDown,
  EmbedActionType.ExpandKebab,
  EmbedActionType.ExploreChart,
  EmbedActionType.ExploreChartMark,
  EmbedActionType.Forward,
  EmbedActionType.ShowAlert,
  EmbedActionType.CopyChart,
  EmbedActionType.ViewData,
  EmbedActionType.ChartRendered,
  EmbedActionType.MuzeChartRendered,
  EmbedActionType.NotebookVisualizationRendered,
  EmbedReportActions.Type.DocumentClick,
  EmbedReportActions.Type.Autogrow,
  EmbedReportActions.Type.DocumentKeydown,
  EmbedReportActions.Type.ReportRendered,
  EmbedReportActions.Type.ReportStartRender,
  EmbedReportActions.Type.SetTableOffset,
  EmbedReportActions.Type.SetTableColumnSearch,
  EmbedReportActions.Type.ExportChartCsv,
  EmbedReportActions.Type.UpdateEncoding,
  EmbedReportActions.Type.UpdateVizIntersections,
  EmbedReportActions.Type.ReportHasScrolled,
  EmbedReportActions.Type.ProgressReporting,
  EmbedReportActions.Type.GetDataProfiling,
  EmbedReportActions.Type.UpdateSortSettings,
  EmbedReportActions.Type.ViewUnaggregatedData,
]);

@Injectable({
  providedIn: 'root',
})
export class ReportActionEmitService {
  constructor(
    $window: Window,
    @Inject(Actions) actions$: Observable<EmbedReportActions.Actions>,
    @Inject(EmitTransportToken) emitter: EmitTransport
  ) {
    actions$
      .pipe(filter((a) => EMITABLE_ACTIONS.has(a.type)))
      .subscribe((a) => emitter.emit($window.parent, new EmitMessages.Action(a)));
  }
}
